export const LOADING_ADD = "LOADING_ADD";
export const LOADING_REMOVE = "LOADING_REMOVE";
export const START_NAVIGATING = "START_NAVIGATING";
export const END_NAVIGATING = "END_NAVIGATING";
